export default __webpack_public_path__ + "static/media/1855.1d07ab6e.png";